import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {RequestService} from '../request/request.service';
import {Observable} from 'rxjs';
import {UserListModel} from '../../../shared/models/user.model';
import * as moment from 'moment';

@Injectable()
export class UserService {
  apiUrl = environment.apiRoot;

  constructor(private reqService: RequestService) { }

  get(filter?): Observable<UserListModel> {
    const req = {
      url: this.apiUrl + 'Account/Users',
      options: {
        params: filter
      }
    };

    return this.reqService.getRequest(req);
  }

  updateUser(object) {
    const req = {
      url: this.apiUrl + 'Account/User',
      data: object
    };

    return this.reqService.putRequest(req);
  }

  inviteUser(object) {
    const req = {
      url: this.apiUrl + 'Account/Invite',
      data: object
    };

    return this.reqService.postRequest(req);
  }

  removeUser(object) {
    const req = {
      url: this.apiUrl + 'Account/' + object.Id,
    };

    return this.reqService.deleteRequest(req);
  }

  getDriverInfo(id) {
    const req = {
      url: this.apiUrl + 'Account/' + id + '/DriverInfo'
    };

    return this.reqService.getRequest(req);
  }

  getAllRoles() {
    const req = {
      url: this.apiUrl + 'Account/AllAvailableRoles'
    };

    return this.reqService.getRequest(req);
  }

  getLinRoles() {
    const req = {
      url: this.apiUrl + 'Account/AvailableLinRoles'
    };

    return this.reqService.getRequest(req);
  }

  getGroupRoles() {
    const req = {
      url: this.apiUrl + 'Account/AvailableGroupRoles'
    };

    return this.reqService.getRequest(req);
  }

  getUnitRoles() {
    const req = {
      url: this.apiUrl + 'Account/AvailableUnitRoles'
    };

    return this.reqService.getRequest(req);
  }

  assignRole(object) {
    const req = {
      url: this.apiUrl + 'Account/AssignRole',
      data: object
    };

    return this.reqService.postRequest(req);
  }

  removeRole(object) {
    const req = {
      url: this.apiUrl + 'Account/RemoveRole',
      data: object
    };

    return this.reqService.deleteRequest(req);
  }

  removeAllRoles(object) {
    const req = {
      url: this.apiUrl + 'Account/RemoveAllRoles',
      data: object
    };

    return this.reqService.postRequest(req);
  }

  resendInvite(object) {
    const req = {
      url: this.apiUrl + 'Account/ResendInvite',
      data: object
    };

    return this.reqService.postRequest(req);
  }

  export(filter?, object?) {
    const req = {
      url: this.apiUrl + 'Account/Users/Export',
      options: {
        responseType: 'arraybuffer',
        params: filter,
      },
      data: object
    };

    const fileName = moment().format('YYYY-MM-DD-HHmm') + '_CasesReport.xlsx';

    return this.reqService.fileSaverPost(req, fileName);
  }

}
